import DocumentDomGenerator from "./documentDomGenerator.class";
import { $elementChild } from "@grindex-common/helpers/elements";
import { Loader } from "@grindex-components/Loader/loader.class";

const HIDDEN_CLASS = "hid";
const ERROR_CLASS = "error";

function init($views) {
	const forms = {};
	var httpRequest;

	const apiRoot = "/api/documents/";
	const htmlParser = new DocumentDomGenerator();

	function getApiUrl(method) {
		return `${apiRoot}${method}`;
	}

	function valid($input) {
		const value = $input && $input.value ? $input.value.trim() : "";

		if ($input.value && $input.value.length > 0 && value.length === 0) {
			$input.value = "";
		}

		return value.length > 0;
	}

	function validate($input, $error) {
		return () => {
			if ($input) {
				if (!valid($input)) {
					$error.classList.remove(HIDDEN_CLASS);
					$input.classList.add(ERROR_CLASS);
					return false;
				}

				$error.classList.add(HIDDEN_CLASS);
				$input.classList.remove(ERROR_CLASS);
			}

			return true;
		};
	}

	$views.forEach(($view) => {
		const $error = $elementChild($view, "search-error");
		const $button = $elementChild($view, "search-submit");
		const $result = $elementChild($view, "search-results");
		const $loader = $elementChild($view, "loader");
		const $form = $view.querySelector("form");
		let $input = $view.querySelector('input[name="query"]');

		if (!$input) {
			$input = $view.querySelector('input[name="search"]');
		}

		forms[$form.dataset.ajaxUpdate] = {
			loader: new Loader($loader),
			validate: validate($input, $error),
			$input,
			$button,
			$result,
		};
	});

	window.documentSearchBegin = function () {
		const form = forms[this.dataset.ajaxUpdate];

		if (!form || !form.validate()) {
			return false;
		}

		const { loader, $button, $result, $input } = form;

		loader.show();
		if ($input) {
			$input.disabled = true;
		}

		$button.disabled = true;
		$result.style.display = "none";
		$result.innerHTML = "";

		return true;
	};

	window.documentSearchComplete = function (data) {
		const results = JSON.parse(data.responseText);

		if (results) {
			const resultsDiv = document.querySelector("#results");

			results.forEach((documentGroup) => {
				const rootDiv = htmlParser.createRootDiv();

				if (documentGroup.heading) {
					rootDiv.appendChild(htmlParser.createHeader("h3", documentGroup.heading));
				}

				if (documentGroup.description) {
					rootDiv.appendChild(htmlParser.createDescription(documentGroup));
				}

				if (documentGroup.showSubHeading && documentGroup.subHeading) {
					rootDiv.appendChild(htmlParser.createHeader("h4", documentGroup.subHeading));
				}

				if (documentGroup.groupMetaData) {
					rootDiv.appendChild(htmlParser.createMetaDataElement(documentGroup));
				}

				if (documentGroup.externalDocuments) {
					const ul = document.createElement("ul");
					htmlParser.createDocumentLinks(documentGroup.externalDocuments).forEach((li) => {
						ul.appendChild(li);
					});

					rootDiv.appendChild(ul);
				}

				rootDiv.appendChild(htmlParser.createDocumentsElement(documentGroup));

				resultsDiv.appendChild(rootDiv);
			});
		}

		const form = forms[this.dataset.ajaxUpdate];

		if (!form) {
			return false;
		}

		const { loader, $button, $result, $input } = form;

		loader.hide();

		if ($input) {
			$input.disabled = false;
		}

		$button.disabled = false;
		$result.style.display = "block";
		window.addClickEventListners();
		return true;
	};

	window.addClickEventListners = function () {
		const resources = document.querySelectorAll(".drawing-search .resources-block");
		for (let i = 0; i < resources.length; i++) {
			resources[i].addEventListener("click", function (e) {
				window.expandDocuments(e);
			});
		}
	};

	window.removeClickEventListners = function () {
		const resources = document.querySelectorAll(".drawing-search .resources-block");
		for (let i = 0; i < resources.length; i++) {
			resources[i].removeEventListener("click", function (e) {
				window.expandDocuments(e);
			});
		}
	};

	window.expandDocuments = function (e) {
		var element = e.target.closest(".resources-block").querySelectorAll(".document-group")[0];

		if (element.classList.contains("active")) {
			element.classList.toggle("active");
			return false;
		}

		if (element.classList.contains("working")) {
			return false;
		}

		element.classList.toggle("working");
		var fileListing = element.querySelectorAll("ul")[0];

		const formData = new FormData();
		formData.append("documentId", element.id);

		httpRequest = new XMLHttpRequest();

		if (!httpRequest) {
			return false;
		}

		httpRequest.onreadystatechange = function () {
			// readyState 4 means the request is done.
			const DONE = 4;

			if (httpRequest.readyState === DONE) {
				// status 200 is a successful return.
				const OK = 200;
				if (httpRequest.status === OK) {
					fileListing.innerHTML = "";
					const response = JSON.parse(httpRequest.response);

					window.createFileListing(fileListing, response);

					element.classList.toggle("active");
					element.classList.toggle("working");
				} else {
					throw new Error(`Error: ${httpRequest.status}`);
				}
			}
		};

		httpRequest.open("POST", getApiUrl("getdrawings"));
		httpRequest.send(formData);
	};

	window.createFileListing = function (fileListingContainer, data) {
		const links = htmlParser.createDocumentLinks(data);

		links.forEach((link) => {
			fileListingContainer.appendChild(link);
		});
	};

	window.updateFilters = function (callingDropdown) {
		const currentDropDown = callingDropdown ? callingDropdown.id : "";
		var dropdowns = document.querySelectorAll(".component-documentSearchBlock select");
		const formData = new FormData();
		for (let i = 0; i < dropdowns.length; i++) {
			dropdowns[i].setAttribute("disabled", true);
			if (dropdowns[i].value !== null) {
				formData.append(dropdowns[i].name, dropdowns[i].value);
			}
		}

		httpRequest = new XMLHttpRequest();

		if (!httpRequest) {
			return false;
		}

		httpRequest.onreadystatechange = function () {
			// readyState 4 means the request is done.
			const DONE = 4;

			if (httpRequest.readyState === DONE) {
				// status 200 is a successful return.
				const OK = 200;
				if (httpRequest.status === OK) {
					const response = JSON.parse(httpRequest.response);

					for (let a = 0; a < dropdowns.length; a++) {
						window.processDropDown(dropdowns[a], response, currentDropDown);
					}

					for (let d = 0; d < dropdowns.length; d++) {
						dropdowns[d].removeAttribute("disabled");
					}
				} else {
					throw new Error(`Error: ${httpRequest.status}`);
				}
			}
		};

		httpRequest.open("POST", getApiUrl("getfilters"));
		httpRequest.send(formData);
	};

	window.processDropDown = function (dropdown, data, currentDropDown) {
		const currentDropdownId = dropdown.id;
		const currentValue = dropdown.value;
		for (let key in data) {
			if (data.hasOwnProperty(key) && key === currentDropdownId && data[key] !== null && currentDropdownId !== currentDropDown) {
				window.resetDropDown(dropdown, currentDropdownId);
				window.populateDropDown(dropdown, currentValue, data[key]);
			}
		}
	};

	window.resetDropDown = function (dropdown, currentDropdownId) {
		const options = document.querySelectorAll("#" + currentDropdownId + " option");
		options.forEach((o) => o.parentNode.removeChild(o));

		const defaultOption = document.createElement("option");
		defaultOption.text = "Please Select";
		defaultOption.value = "";
		dropdown.add(defaultOption);
	};

	window.populateDropDown = function (dropdown, currentValue, data) {
		for (let e = 0; e < data.length; e++) {
			const option = document.createElement("option");
			option.text = data[e].text;
			option.value = data[e].text;

			if (data[e].text === currentValue) {
				option.selected = "selected";
			}

			dropdown.add(option);
		}
	};

	window.clearFilters = function () {
		const dropdowns = document.querySelectorAll(".component-documentSearchBlock select");
		for (let e = 0; e < dropdowns.length; e++) {
			dropdowns[e].selectedIndex = 0;
		}
		window.updateFilters();
	};
}

export default {
	view: "document-search-block",
	init,
};
